import React from "react";
import { Link, Outlet } from "react-router-dom";
import InssureLogo from "../../Components/InssureLogo";
import "./HelpCenter.css";

export default function HelpCenterLayout() {
  return (
    <div className="help-center">
      <header className="help-center-topbar">
        <Link to="/help" className="help-center-brand" aria-label="inSure Help Center home">
          <InssureLogo />
          <span className="help-center-brand-label">Help Center</span>
        </Link>
      </header>
      <main className="help-center-main">
        <Outlet />
      </main>
    </div>
  );
}
